import { queryKey } from '../constants/queryClientKey';
import {
  createFilterManagement,
  deleteFilterManagement,
  getFiltersManagement,
  getFiltersTree,
  updateFilterManagement,
} from '../apis/filterManagement.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

export function useGetFiltersManagement(
  params: Parameters<typeof getFiltersManagement>[0],
  options?: UseQueryOptions
) {
  return useQuery(
    [queryKey.filter_management, sortObjectKeys(params)],
    () => getFiltersManagement(params),
    {
      keepPreviousData: true,
      ...options,
    }
  ) as UseQueryResult<Awaited<ReturnType<typeof getFiltersManagement>>>;
}

export function useGetFiltersTree() {
  return useQuery([queryKey.filter_tree], () => getFiltersTree(), {
    // refetchOnWindowFocus: true,
    keepPreviousData: true,
  });
}

export function useCreateFilterManagement() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: Parameters<typeof createFilterManagement>[0]) => createFilterManagement(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.filter_management]);
      },
      //? Maybe can use onSettled for both onSuccess and onError
      onError: (err) => {
        console.error('useCreateFilterManagement', err);
      },
    }
  );
}

export function useUpdateFilterManagement() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: Parameters<typeof createFilterManagement>[0] }) =>
      updateFilterManagement(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.filter_management]);
      },

      onError: (err) => {
        console.error('useUpdateFilterManagement', err);
        queryClient.invalidateQueries([queryKey.filter_management]);
      },
    }
  );
}

export function useDeleteFilterManagement() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteFilterManagement(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.filter_management]);
    },

    onError: (err) => {
      console.error('useDeleteFilterManagement', err);
      queryClient.invalidateQueries([queryKey.filter_management]);
    },
  });
}
